"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _tokens = require("../../../tokens");

var _versions = require("../../_utils/versions");

var _context = require("../../context");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  vertical-align: middle;\n  font-size: ", ";\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  color: ", ";\n  padding-left: ", ";\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n          &:active {\n            &:before {\n              width: ", ";\n              left: ", ";\n            }\n          }\n        "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n          opacity: 0.4;\n        "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  vertical-align: middle;\n  display: inline-block;\n  width: ", ";\n  height: ", ";\n  border-radius: ", ";\n  background: ", ";\n  cursor: pointer;\n  position: relative;\n\n  &:before {\n    content: '';\n    display: block;\n    position: absolute;\n    top: ", ";\n    left: ", ";\n    width: ", ";\n    height: ", ";\n    border-radius: ", ";\n    background: ", ";\n    box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.25), 0 4px 11px 0 rgba(0, 0, 0, 0.08),\n      -1px 3px 3px 0 rgba(0, 0, 0, 0.14);\n    transition: transform ", " ease,\n    width ", ", left ", ";\n  }\n\n  ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  width: 0;\n  opacity: 0;\n  position: absolute;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  vertical-align: middle;\n  position: relative;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var small = {
  height: '16px',
  width: '26px',
  circle: {
    height: '14px',
    width: '14px'
  },
  activeWidth: '17px',
  off: {
    left: '1px',
    top: '1px'
  },
  on: {
    left: '11px',
    top: '1px'
  }
};
var large = {
  height: '32px',
  width: '55px',
  circle: {
    height: '24px',
    width: '24px'
  },
  activeWidth: '30px',
  off: {
    left: '4px',
    top: '4px'
  },
  on: {
    left: '28px',
    top: '4px'
  }
};

var getColors = function getColors(props) {
  var switchColors = (0, _versions.getColor)(props, 'switch');
  var textColors = (0, _versions.getColor)(props, 'text');
  return {
    switchColors: switchColors,
    textColors: textColors
  };
};

var getStaticProperties = function getStaticProperties(props) {
  var sizes = (0, _versions.getProperties)(props, 'switch');
  return sizes[props.size];
};

var StyledSwitch = _styledComponents["default"].span(_templateObject());

var Checkbox = _styledComponents["default"].input(_templateObject2());

var Toggle = _styledComponents["default"].span(_templateObject3(), function (props) {
  return getStaticProperties(props).width;
}, function (props) {
  return getStaticProperties(props).height;
}, function (props) {
  return getStaticProperties(props).radius;
}, function (props) {
  return props.on ? getColors(props).switchColors.onBackground : getColors(props).switchColors.offBackground;
}, function (props) {
  return props.size === 'small' ? small.off.top : large.off.top;
}, function (props) {
  if (props.on) {
    return props.size === 'small' ? small.on.left : large.on.left;
  }

  return props.size === 'small' ? small.off.left : large.off.left;
}, function (props) {
  return getStaticProperties(props).circle.width;
}, function (props) {
  return getStaticProperties(props).circle.height;
}, function (props) {
  return getStaticProperties(props).radius;
}, function (props) {
  return getColors(props).switchColors.toggler;
}, _tokens.misc.animationDuration, _tokens.misc.animationDuration, _tokens.misc.animationDuration, function (props) {
  return props.readOnly ? (0, _styledComponents.css)(_templateObject4()) : (0, _styledComponents.css)(_templateObject5(), function (props) {
    return getStaticProperties(props).activeWidth;
  }, function (props) {
    if (props.size === 'large') {
      return props.on ? '16px' : '6px';
    }

    return '6px';
  });
});

var Label = _styledComponents["default"].label(_templateObject6(), _tokens.fonts.size.small, function (props) {
  return getColors(props).textColors.secondary;
}, _tokens.spacing.small);

var Switch =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Switch, _React$Component);

  //eslint-disable-line
  function Switch(props) {
    var _this;

    _classCallCheck(this, Switch);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Switch).call(this, props));
    _this.state = {
      on: props.on
    };
    return _this;
  }

  _createClass(Switch, [{
    key: "onToggle",
    value: function onToggle() {
      var _this2 = this;

      if (this.props.readOnly) return;
      this.setState(function (currentState) {
        if (_this2.props.onToggle) _this2.props.onToggle(!currentState.on);
        return {
          on: !currentState.on
        };
      });
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      if (newProps.on !== this.state.on) this.setState({
        on: newProps.on
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$accessibl = _slicedToArray(this.props.accessibleLabels, 2),
          onLabel = _this$props$accessibl[0],
          offLabel = _this$props$accessibl[1];
      /*
        The checkbox is controlled by the component state
        and is itself a readOnly component
      */


      return _react["default"].createElement(StyledSwitch, {
        onClick: this.onToggle.bind(this)
      }, _react["default"].createElement(Checkbox, {
        type: "checkbox",
        checked: this.state.on,
        readOnly: true
      }), _react["default"].createElement(Toggle, _extends({}, this.props, {
        on: this.state.on,
        readOnly: this.props.readOnly,
        version: this.props.version
      })), _react["default"].createElement(Label, {
        version: this.props.version
      }, this.state.on ? onLabel : offLabel));
    }
  }]);

  return Switch;
}(_react["default"].Component);

Switch.propTypes = {
  onToggle: _propTypes["default"].func,
  on: _propTypes["default"].bool,
  accessibleLabels: _propTypes["default"].arrayOf(_propTypes["default"].string),
  size: _propTypes["default"].oneOf(['small', 'large']),
  readOnly: _propTypes["default"].bool
};
Switch.defaultProps = {
  onToggle: null,
  on: false,
  size: 'large',
  accessibleLabels: ['Enabled', 'Disabled'],
  readOnly: false
};
Switch.displayName = 'Switch';

var _default = (0, _context.withVersion)(Switch);

exports["default"] = _default;